export default function MembersIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 5C7.79 5 6 6.79 6 9C6 11.21 7.79 13 10 13C12.21 13 14 11.21 14 9C14 6.79 12.21 5 10 5ZM10 11C8.9 11 8 10.1 8 9C8 7.9 8.9 7 10 7C11.1 7 12 7.9 12 9C12 10.1 11.1 11 10 11ZM10 14C7 14 3 16.34 3 19L5 19.01C5 19.01 11.0948 19.0039 15 19C15.781 19 17 19 17 19C17 16.34 13 14 10 14ZM5 19.01C5.2 18.29 7 16 10 16C13 16 14.8 18.29 15 19C11.0948 19.0039 5 19.01 5 19.01ZM14.51 5.05C15.43 6.11 16 7.49 16 9C16 10.51 15.43 11.89 14.51 12.95C16.47 12.7 18 11.04 18 9C18 6.96 16.47 5.3 14.51 5.05ZM17 15C17.89 15.83 19 17.7 19 19H21C21 17.55 18.88 15.66 17 15Z"
        fill="var(--text-secondary-color)"
      />
    </svg>
  );
}
